/* eslint-disable react/require-default-props */

//biome-ignore lint/style/useImportType: this is usefulle
import * as React from "react";

import { CSSTransition, SwitchTransition } from "react-transition-group";

import { Breadcrumb } from "semantic-ui-react";

export type ApplicationBreadcrumbSectionChildrenProps = {
	children?: never;
	key: string;
	libelle?: string;
};

export type ApplicationBreadcrumbSectionLibelleProps = {
	children?: React.ReactNode;
	key: string;
	libelle?: never;
};

const ApplicationBreadcrumbSection = (
	props:
		| ApplicationBreadcrumbSectionChildrenProps
		| ApplicationBreadcrumbSectionLibelleProps,
) => {
	const { children, libelle } = props;

	return (
		<Breadcrumb.Section>
			<SwitchTransition>
				<CSSTransition
					key={libelle}
					addEndListener={(node, done) =>
						node.addEventListener("transitionend", done, false)
					}
					classNames="fade"
				>
					<span data-testid={`section${libelle ? `.${libelle}` : ""}`}>
						{libelle || children}
					</span>
				</CSSTransition>
			</SwitchTransition>
		</Breadcrumb.Section>
	);
};

export default ApplicationBreadcrumbSection;
